import React from 'react';
import { 
  HelpCircle, 
  Apple, 
  Clock, 
  Droplet, 
  Utensils, 
  ZoomIn, 
  Heart, 
  Dumbbell 
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по метаболизму
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Apple,
      title: 'Качество питания',
      description: 'Отдавайте предпочтение необработанным продуктам: овощам, фруктам, цельным злакам, нежирным белкам.'
    },
    {
      icon: Clock,
      title: 'Регулярное питание',
      description: 'Придерживайтесь режима приемов пищи, чтобы стабилизировать уровень сахара в крови и избежать переедания.'
    },
    {
      icon: Droplet,
      title: 'Водный баланс',
      description: 'Пейте достаточно воды — около 30 мл на кг веса. Вода ускоряет метаболизм на 25-30%.'
    },
    {
      icon: Utensils,
      title: 'Размер порций',
      description: 'Контролируйте размер порций — используйте меньшую посуду и тщательно пережевывайте пищу.'
    },
    {
      icon: ZoomIn,
      title: 'Контроль калорий',
      description: 'Ведите дневник питания хотя бы первое время — это повышает осознанность и снижает потребление на 15-20%.'
    },
    {
      icon: Heart,
      title: 'Здоровый сон',
      description: 'Спите 7-8 часов в сутки. Недостаток сна снижает метаболизм и повышает аппетит.'
    },
    {
      icon: Dumbbell,
      title: 'Силовые тренировки',
      description: 'Увеличивайте мышечную массу — каждый кг мышц сжигает до 50 ккал в день даже в состоянии покоя.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-emerald-500" />
        Советы для здорового метаболизма
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HeartPulse className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-emerald-700 dark:text-emerald-300 mb-2">
              Помните!
            </h4>
            <p className="text-xs text-emerald-600 dark:text-emerald-400 mb-3">
              Здоровый метаболизм — это не только о калориях, но и о качестве питания, 
              физической активности и психологическом благополучии.
            </p>
            <a 
              href="https://www.rospotrebnadzor.ru/about/info/news/news_details.php?ELEMENT_ID=14196" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-full py-1.5 text-xs block text-center bg-emerald-500 text-white rounded hover:bg-emerald-600 transition-colors"
            >
              Подробнее о здоровом питании
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

// Иконка сердца с пульсом (нет в lucide-react)
const HeartPulse = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    <path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27" />
  </svg>
);

export default TipsSidebar;